import { c as _c } from "react-compiler-runtime";
import { useEffect, useState } from 'react';
export const useIsObscuredByFrozenColumn = t0 => {
  const $ = _c(6);
  const {
    anchorElement,
    scrollContainerElementRef,
    isColumnFrozen,
    numberOfFrozenColumns
  } = t0;
  const [overlapObscured, setOverlapObscured] = useState(false);
  let t1;
  let t2;
  if ($[0] !== anchorElement || $[1] !== isColumnFrozen || $[2] !== numberOfFrozenColumns || $[3] !== scrollContainerElementRef) {
    t1 = () => {
      const scrollContainer = scrollContainerElementRef.current;
      if (!anchorElement || !scrollContainer || isColumnFrozen || numberOfFrozenColumns === 0) {
        return;
      }
      let cancelled = false;
      const lastFrozenHeader = scrollContainer.querySelector(`thead > tr > th[data-column-index="${numberOfFrozenColumns - 1}"]`);
      const updateOverlapFromDom = () => {
        if (cancelled) {
          return;
        }
        if (!lastFrozenHeader) {
          setOverlapObscured(false);
          return;
        }
        const anchorLeftEdgePx = anchorElement.getBoundingClientRect().left;
        const frozenBlockRightEdgePx = lastFrozenHeader.getBoundingClientRect().right;
        const anchorIsHiddenBehindFrozenColumns = anchorLeftEdgePx < frozenBlockRightEdgePx;
        setOverlapObscured(anchorIsHiddenBehindFrozenColumns);
      };
      queueMicrotask(updateOverlapFromDom);
      scrollContainer.addEventListener("scroll", updateOverlapFromDom, {
        passive: true
      });
      return () => {
        cancelled = true;
        scrollContainer.removeEventListener("scroll", updateOverlapFromDom);
        setOverlapObscured(false);
      };
    };
    t2 = [anchorElement, scrollContainerElementRef, isColumnFrozen, numberOfFrozenColumns];
    $[0] = anchorElement;
    $[1] = isColumnFrozen;
    $[2] = numberOfFrozenColumns;
    $[3] = scrollContainerElementRef;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  return overlapObscured;
};